import api from '../services/api';
import { querystring } from '../utils/resposta';

// Pedido de perfil Profissional. Quem pede é sempre o usuário autenticado.
export const TIPOS_ATUACAO = [
  'Proprietário rural',
  'Empresa',
  'ONG ou organização',
  'Instituição de ensino ou pesquisa',
  'Poder público',
  'Outro',
];

const SolicitacaoProfissional = {
  model: { tipo_atuacao: '', organizacao: '', telefone: '', area_estimada_ha: '', mensagem: '' },

  // { tipo, solicitacao } — o papel atual e o pedido mais recente (ou null).
  minha: async function () {
    return await api.get('/solicitacoes-profissional/minha')
      .then(response => response)
      .catch(error => error);
  },

  create: async function (data) {
    return await api.post('/solicitacoes-profissional', data)
      .then(response => response)
      .catch(error => error);
  },

  // Administrador
  findAll: async function (page = 1, limit = 10, status = '') {
    return await api.get(`/solicitacoes-profissional/all/${page}/${limit}${querystring({ status })}`)
      .then(response => response)
      .catch(error => error);
  },

  contagem: async function () {
    return await api.get('/solicitacoes-profissional/contagem')
      .then(response => response)
      .catch(error => error);
  },

  aprovar: async function (id, resposta) {
    return await api.patch(`/solicitacoes-profissional/${id}/aprovar`, resposta ? { resposta } : {})
      .then(response => response)
      .catch(error => error);
  },

  recusar: async function (id, resposta) {
    return await api.patch(`/solicitacoes-profissional/${id}/recusar`, { resposta })
      .then(response => response)
      .catch(error => error);
  },
};

export default SolicitacaoProfissional;
